import React from 'react';
import {Glob as G} from "../../libs/Glob.mjs";
import {Button, ButtonGroup, Input} from "reactstrap";
import TextLabel from "../../controls/TextLabel.mjs";
import TrashIcon from "../../media/images/TrashIcon.mjs";
import ChevronUpIcon from "../../media/images/ChevronUpIcon.mjs";
import ChevronDownIcon from "../../media/images/ChevronDownIcon.mjs";
import EditIcon from "../../media/images/EditIcon.mjs";
import CheckIcon from "../../media/images/CheckIcon.mjs";

const EditorSubOptions = class extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			orig: props.options || [],
			options: props.options ? G.clone(props.options) : []
		}
		this.uid = G.generateUid('options');
		this.swap = this.swap.bind(this);
	}

	swap(from, to) {
		const o = this.state.options;
		const a = G.clone(o[from]);
		const b = G.clone(o[to]);
		o[from] = b;
		o[to] = a;
		this.setState({options: o, addValue: undefined, addLabel: undefined, addIcon: undefined}, () => {
			this.props.setValue(o);
		});
	}

	render() {
		return (
			<template
				className={"d-block"}
				shadowrootmode="open"
				shadowrootdelegatesfocus={"true"}
			>
				<table className={"SubfieldOptions"}>
					<thead>
					<tr>
						<th style={{width: "80px", textAlign: "center"}}>Value</th>
						<th style={{padding: "0 16px"}}>Label</th>
						<th/>
					</tr>
					</thead>
					<tbody>
					{this.state.options.map((opt, idx) => (
						<tr key={idx}>
							<td align={"center"}>{opt.value}</td>
							<td style={{padding: "0 16px"}}>{opt.label}</td>
							<td>
								<ButtonGroup className={"btn-icon"}>
									<Button
										color="link"
										onClick={() => {
											this.setState({
												addValue: opt.value,
												addLabel: opt.label,
												addIndex: idx
											})
										}}
									>
										<EditIcon/>
									</Button>
									<Button
										color={"link"}
										onClick={() => {
											if (window.confirm(`Confermi l’eliminazione di “${opt.label}?”`)) {
												const o = this.state.options;
												o.splice(idx, 1);
												this.setState({options: o}, () => {
													this.props.setValue(o);
												});
											}
										}}
									>
										<TrashIcon/>
									</Button>
									<Button
										disabled={idx === 0}
										color="link"
										onClick={() => {
											this.swap(idx, idx - 1)
										}}
									>
										<ChevronUpIcon/>
									</Button>
									<Button
										disabled={idx >= (this.state.options.length - 1)}
										color="link"
										onClick={() => {
											this.swap(idx, idx + 1)
										}}
									>
										<ChevronDownIcon/>
									</Button>
								</ButtonGroup>
							</td>
						</tr>
					))}
					<tr>
						<td>
							<Input
								style={{textAlign: "center"}}
								type={"text"}
								value={this.state.addValue || ''}
								onChange={(e) => {
									this.setState({addValue: e.target.value});
								}}
							/>
						</td>
						<td>
							<Input
								type={"text"}
								value={this.state.addLabel || ''}
								onChange={event => {
									this.setState({addLabel: event.target.value});
								}}
							/>
						</td>
						<td align={"center"}>
							<ButtonGroup>
								<Button
									color={"warning"}
									onClick={() => {
										this.setState({addValue: '', addLabel: '', addIndex: undefined})
									}}
								>
									<TextLabel value={"close"} lang={"icon"}/>
								</Button>
								<Button
									className={"btn-icon"}
									disabled={!this.state.addLabel}
									color={this.state.addLabel ? 'success' : 'secondary'}
									onClick={() => {
										const o = this.state.options;
										if (typeof this.state.addIndex === 'number') {
											o[this.state.addIndex] = {
												label: this.state.addLabel,
												value: this.state.addValue
											};
										} else {
											o.push({label: this.state.addLabel, value: this.state.addValue});
										}
										this.setState({
											options: o,
											addValue: '',
											addLabel: '',
											addIndex: undefined
										}, () => {
											this.props.setValue(o);
										});
									}}
								>
									{typeof this.state.addIndex === 'number' ? <EditIcon/> : <CheckIcon/>}
								</Button>
							</ButtonGroup>
						</td>
					</tr>
					</tbody>
				</table>
			</template>
		)
	}
}

export default EditorSubOptions;
